module.exports = __webpack_public_path__ + "static/img/load_1.797c06f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/load_1.png
// module id = JiYt
// module chunks = 1